import { Button, Select } from "antd";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import CreateProfileCardWrapper from "../../components/common/CreateProfileCardWrapper";
import { setInfoContent } from "../../redux/slices/common_slice";
import CanadaData from "../../utils/state-cities.json";
import "./OnboardingPage.css";

const { Option } = Select;

const LocationForm = ({ formik }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const inputRef = useRef();
  const removeFocus = () => {
    if (inputRef.current) {
      inputRef.current.blur();
    }
  };

  const citiesArr = formik.values?.province
    ? CanadaData?.find((item) => item?.name === formik.values?.province)?.cities
    : [];
  return (
    <>
      <CreateProfileCardWrapper>
        <h5 className="d-flex align-items-center justify-content-between">
          {t("aboutYou.ques5.title")}
        </h5>
        <Select
          className={`custom-common-select-box ${
            formik.touched.province && formik.errors.province
              ? "error-fill"
              : formik.values.province
              ? "data-fill"
              : ""
          }`}
          placeholder={t("aboutYou.ques5.placeholder")}
          onChange={(e) => {
            formik.setFieldValue("province", e);
            formik.setFieldValue("city", undefined);
          }}
          onBlur={formik.handleBlur("province")}
          value={formik.values.province}
          allowClear={false}
        >
          {CanadaData.map((province) => (
            <Option key={province?.name} value={province?.name}>
              {t(`aboutYou.pronvices.${province?.name}`)}
            </Option>
          ))}
        </Select>
        {!formik.values.province &&
        formik.touched.province &&
        formik.errors.province ? (
          <div className="error-message">{formik.errors.province}</div>
        ) : null}
      </CreateProfileCardWrapper>

      <CreateProfileCardWrapper>
        <h5 className="d-flex align-items-center justify-content-between">
          {t("aboutYou.ques6.title")}
          <Button
            className="border-0 bg-tranaparent w-auto h-auto shadow-none p-0 info-icon-btn"
            onClick={() => {
              dispatch(setInfoContent(t("aboutYou.resources.2")));
            }}
          >
            <img
              src="/assets/images/icons/info-circle-icon.svg"
              alt=""
              className="img-fluid"
            />
          </Button>
        </h5>
        <Select
          ref={inputRef}
          className={`custom-common-select-box ${
            formik.touched.city && formik.errors.city
              ? "error-fill"
              : formik.values.city
              ? "data-fill"
              : ""
          }`}
          placeholder={t("aboutYou.ques6.placeholder")}
          disabled={!formik.values.province}
          onChange={(e) => {
            formik.setFieldValue("city", e);
            removeFocus();
          }}
          value={formik.values.city}
          allowClear={false}
          showSearch={true}
        >
          {formik.values.province &&
            citiesArr.sort().map((city) => (
              <Option key={city?.name} value={city?.name}>
                {city?.name}
              </Option>
            ))}
        </Select>
        {formik.touched.city && formik.errors.city ? (
          <div className="error-message">{formik.errors.city}</div>
        ) : null}
      </CreateProfileCardWrapper>
    </>
  );
};

export default LocationForm;
